import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import CommonTable from '../../CommonTable/CommonTable';
import { censorEmail } from '../../../helpers/secureEmail';
import { decode } from '../../../helpers/queryEncryption';
import messages from '../../../locale/messages';
class ReportManagementInformation extends React.Component {

    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            userId: PropTypes.number.isRequired,
            reporterId: PropTypes.string.isRequired,
            reporterType: PropTypes.string.isRequired,
        })),
        formatMessage: PropTypes.func.isRequired,
    };

    static defaultProps = {
        data: []
    };

    thead = () => {
        const { formatMessage } = this.props;
        return [
            { data: formatMessage(messages.idLabel) },
            { data: formatMessage(messages.reporterName) },
            { data: formatMessage(messages.reporterEmail) },
            { data: formatMessage(messages.userNameLabel) },
            { data: formatMessage(messages.userEmailLabel) },
            { data: formatMessage(messages.reportType) },
            { data: formatMessage(messages.transferDate) }
        ]
    }

    tbody = (props) => {
        const { reportUserManagement, formatMessage, isRestrict } = props;

        return reportUserManagement?.reportsData?.map((value, index) => {
            let transferDate, reportType;
            transferDate = moment(parseInt(value?.createdAt)).format('DD/MM/YYYY');
            reportType = value?.reportType == "Shouldn't available" ? formatMessage(messages.reportStatus1) : (value?.reportType == 'Direct contact' ? formatMessage(messages.reportStatus2) : formatMessage(messages.reportStatus3));
            return {
                id: index,
                data: [
                    { data: value?.id },
                    { data: value?.reporterData?.displayName ? value?.reporterData?.displayName : formatMessage(messages.userDeletedLabel) },
                    {
                        data: value?.reporterEncryptEmail?.email ? <a href={"/users/show/" + value?.userProfileId?.profileId} target="_blank">
                            {!isRestrict ? decode(value?.reporterEncryptEmail?.email) : censorEmail(decode(value?.reporterEncryptEmail?.email))}
                        </a> : formatMessage(messages.userDeletedLabel)
                    },
                    { data: value?.userData?.displayName ? value?.userData?.displayName : formatMessage(messages.userDeletedLabel) },
                    {
                        data: value?.userEncryptEmail?.email ? <a href={"/users/show/" + value?.userData?.profileId} target="_blank">
                            {!isRestrict ? decode(value?.userEncryptEmail?.email) : censorEmail(decode(value?.userEncryptEmail?.email))}
                        </a> : formatMessage(messages.userDeletedLabel)
                    },
                    { data: reportType },
                    { data: transferDate }
                ]
            };
        })

    }

    render() {
        const { reportUserManagement, formatMessage, handleSearch } = this.props;

        return (
            <CommonTable
                title={formatMessage(messages.reportManagement)}
                thead={this.thead}
                tbody={() => this.tbody(this.props)}
                isSearch
                handleSearch={handleSearch}
            />
        );
    }
}

export default ReportManagementInformation;